import {Confirm, useOpenModal} from '@/components/Modal/index.mjs'
import AddPreToIsrfDlg from '@/pages/MainPage/panes/PrjPatternDetail/AddPreToIsrfDlg.jsx'

export const canAddNodeToIsrfNew = () => () => {
    return function (nodes) {
        return [...nodes].filter(node => {
            const {bizNodeType, pkid, prjId, rev} = node.data
            const {classes} = this.BizNode[bizNodeType]

            return (
                pkid &&
                rev &&
                prjId === this.data.prjId &&
                classes.includes('design') &&
                ! classes.includes('arch') &&
                ! classes.includes('module')
            )
        })
    }
}

export const addNodeToIsrfNew = () => () => {
    const openModal = useOpenModal()

    return async function (nodes) {
        const {prjId, prjPatternId, sVer} = this.data

        const modules = nodes.map(n => {
            const {bizNodeType, pkid} = n.data
            const _n = this.nodeProxy(n)
            const moduleName = _n.getTextRaw()

            return {
                moduleId: pkid,
                moduleName,
                moduleType: bizNodeType,
            }
        })

        const param = {modules, prjId, prjPatternId, sVer}
        const data = await openModal(<AddPreToIsrfDlg param={param} />)

        if (! data) {
            return
        }

        const isConfirmed = await openModal(
            <Confirm>加入软件SPEC单成功！是否跳转到软件SPEC单详情？</Confirm>
        )

        if (isConfirmed) {
            this.BizNode.ISRF.gotoCurrent(this, {data})
        }
    }
}
